import { FC, useRef, useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useRouter } from 'next/router'
import { Button, Heading, Text, InputField, Modal } from '@saasalerts/ui'

export const ReportAccessKey: FC<
  React.PropsWithChildren<{ invalidAccessKey?: boolean }>
> = ({ invalidAccessKey }) => {
  const { register } = useForm<{ accessKey: string }>()
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [mounted, setMounted] = useState(false)
  const router = useRouter()
  const postUrl = `${router.pathname}?token=${router.query.token}&timezone=${
    Intl.DateTimeFormat().resolvedOptions().timeZone
  }`

  const formRef = useRef<HTMLFormElement>(null)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return null

  return (
    <Modal open={true} setOpen={() => setOpen(!open)}>
      <Modal.Header>
        <Modal.TitleBar>
          <Heading type="h2">Enter Report Access Key</Heading>
        </Modal.TitleBar>
      </Modal.Header>
      <Modal.Body>
        <Text className="pb-2">
          Please enter the report access key that you received via email from
          your MSP partner below.
        </Text>
        <form
          ref={formRef}
          action={postUrl}
          method="POST"
          className="space-y-2"
          onSubmit={() => setLoading(true)}
        >
          <InputField
            {...register('accessKey')}
            label="Access Key"
            name="accessKey"
            type="text"
            required
            autoFocus
            ref={inputRef}
          />
          {invalidAccessKey && (
            <Text color="danger">
              Invalid Access Key. Please enter the correct access key for this
              report.
            </Text>
          )}
          {loading && (
            <Text>Your report is loading, this may take several minutes.</Text>
          )}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => formRef.current?.requestSubmit()}
          loading={loading}
          loadingText="Authenticating"
        >
          Authenticate
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
